import { v4 as uuidv4 } from 'uuid';
import { Conversation, FormJourneyItem } from "@plura/shared/types";

export const createDefaultValuesForLeadForm = (items: FormJourneyItem[], previousConversation: Conversation | null) => {
  return items.reduce((acc, step) => {
    const existingUserResponse = previousConversation?.conversationItem?.find(item => item.journeyItemId === step.id && item.role === 'User')?.content

    if (step.type === 'MULTIPLE_CHOICE') {
      acc[step.blockId] = existingUserResponse?.split(',') ?? [];
    } else if (step.type === 'OPEN_ENDED') {
      const responses = previousConversation?.conversationItem
        ?.filter(item => item.journeyItemId === step.id)
        .sort((a, b) => a.createdAt.getTime() - b.createdAt.getTime())
        .map(item => ({
          id: item.id,
          data: {
            id: item.id,
            blockId: item.journeyItemId,
            response: item.content,
            type: item.role,
          }
        })) ?? [];

      // Check if the last item is not of type 'User' and add a default one if needed
      if (responses.length && responses[responses.length - 1]?.data.type !== 'User') {
        const uuid = uuidv4();
        responses.push({
          id: uuid,
          data: {
            id: uuid,
            blockId: step.id,
            response: '',
            type: 'User',
          }
        });
      }

      acc[step.blockId] = responses;
    } else if (step.type === 'CONTACT_INFO') {
      const parsed = JSON.parse(existingUserResponse ? existingUserResponse : '{}');
      const firstName = typeof parsed === 'object' && parsed !== null ? parsed.first_name ?? '' : '';
      const lastName = typeof parsed === 'object' && parsed !== null ? parsed.last_name ?? '' : '';
      const email = typeof parsed === 'object' && parsed !== null ? parsed.email ?? '' : '';
      const phone = typeof parsed === 'object' && parsed !== null ? parsed.phone ?? '' : '';
      const company = typeof parsed === 'object' && parsed !== null ? parsed.company ?? '' : '';

      acc[`${step.blockId}_first_name`] = firstName;
      acc[`${step.blockId}_last_name`] = lastName;
      acc[`${step.blockId}_email`] = email;
      acc[`${step.blockId}_phone`] = phone;
      acc[`${step.blockId}_company`] = company;
    } else if (step.type === 'ADDRESS') {
      const parsed = JSON.parse(existingUserResponse ? existingUserResponse : '{}');
      const address_line_1 = typeof parsed === 'object' && parsed !== null ? parsed.address_line_1 ?? '' : '';
      const address_line_2 = typeof parsed === 'object' && parsed !== null ? parsed.address_line_2 ?? '' : '';
      const city = typeof parsed === 'object' && parsed !== null ? parsed.city ?? '' : '';
      const region = typeof parsed === 'object' && parsed !== null ? parsed.region ?? '' : '';
      const postal_code = typeof parsed === 'object' && parsed !== null ? parsed.postal_code ?? '' : '';
      const country = typeof parsed === 'object' && parsed !== null ? parsed.country ?? '' : '';

      acc[`${step.blockId}_address_line_1`] = address_line_1;
      acc[`${step.blockId}_address_line_2`] = address_line_2;
      acc[`${step.blockId}_city`] = city;
      acc[`${step.blockId}_region`] = region;
      acc[`${step.blockId}_postal_code`] = postal_code;
      acc[`${step.blockId}_country`] = country;
    } else {
      acc[step.blockId] = existingUserResponse ?? '';
    }
    return acc;
  }, {} as Record<string, any>);
}

export const resetDefaultValuesToBlank = (items: FormJourneyItem[]) => {
  return items.reduce((acc, step) => {
    if (step.type === 'MULTIPLE_CHOICE' && step.multiSelect) {
      acc[step.blockId] = [];
    } else if (step.type === 'OPEN_ENDED') {
      acc[step.blockId] = [];
    } else if (step.type === 'CONTACT_INFO') {
      acc[`${step.blockId}_first_name`] = '';
      acc[`${step.blockId}_last_name`] = '';
      acc[`${step.blockId}_email`] = '';
      acc[`${step.blockId}_phone`] = '';
      acc[`${step.blockId}_company`] = '';
    } else if (step.type === 'ADDRESS') {
      acc[`${step.blockId}_address_line_1`] = '';
      acc[`${step.blockId}_address_line_2`] = '';
      acc[`${step.blockId}_city`] = '';
      acc[`${step.blockId}_region`] = '';
      acc[`${step.blockId}_postal_code`] = '';
      acc[`${step.blockId}_country`] = '';
    } else {
      acc[step.blockId] = '';
    }
    return acc;
  }, {} as Record<string, any>);
}